import { createGuestReview } from '../reviewApiClient';

export const FETCH_REVIEWS_SUCCESS = 'FETCH_REVIEWS_SUCCESS';
export const STAGE_NEW_REVIEW = 'STAGE_NEW_REVIEW';
export const CORRECT_REVIEW = 'CORRECT_REVIEW';
export const SUBMIT_REVIEW_PENDING = 'SUBMIT_REVIEW_PENDING';
export const SUBMIT_REVIEW_SUCCESS = 'SUBMIT_REVIEW_SUCCESS';

export function receiveNewReview(reviewPayload) {
  return {
    type: FETCH_REVIEWS_SUCCESS,
    payload: reviewPayload,
  };
}

export function stageNewReview(ratings, reviewText, npsScore) {
  return {
    type: STAGE_NEW_REVIEW,
    payload: {
      ratings,
      reviewText,
      npsScore,
    },
  };
}

export function correctReview() {
  return {
    type: CORRECT_REVIEW,
  };
}

export function submitGuestReview(locale, invitationCode, ratings, reviewText, npsScore) {
  return async (dispatch) => {
    dispatch({
      type: SUBMIT_REVIEW_PENDING,
    });
    await createGuestReview(locale, invitationCode, ratings, reviewText, npsScore);
    dispatch({
      type: SUBMIT_REVIEW_SUCCESS,
    });
  };
}
